// engine
import { ArController } from '@aceroll/core';

export class CheckBalance extends ArController {
    onStart() {
        this.stop();
    }
}